import { Controller } from "@hotwired/stimulus"
import "@selectize/selectize"

export default class extends Controller {
  static targets = ["form", "container", "persona", "selector", "loaderText"]
  static values = {
    campaignId: String
  }

  connect() {
    this._setUpSelectizeElements()
  }

  // Clean up selectize instances
  disconnect() {
    this.selectizeElements?.forEach(element => element.destroy())
  }

  // Setup selectize for all selector targets
  _setUpSelectizeElements() {
    this.selectizeElements = this.selectorTargets.map(element => {
      return $(element).selectize({
        persist: false,
        create: false,
        copyClassesToDropdown: false,
        sortField: "text",
        lockOptgroupOrder: true,
        plugins: ["auto_position"],
        dropdownParent: "body",
        placeholder: element.dataset.placeholder,
        render: {
          option: function(data, escape) {
            return `<div class="option">
              <span class="fw-medium">${escape(data.text)}</span>
              <span class="h-hint">${data.helpText}</span>
            </div>`
          },
          item: function(data, escape) {
            return `<div class="item">${escape(data.text)}</div>`
          }
        },
        onInitialize: function() {
          this.$control.addClass("h-select--block")
          this.$dropdown.addClass("selectize-dropdown--auto-width")
        }
      })[0].selectize
    })
  }


  generatePersona(event) {
    event.preventDefault()

    const persona = this.personaTarget
    const csrfToken = document.querySelector("[name='csrf-token']")?.content
    persona.disabled = true

    fetch(`/campaigns/${this.campaignIdValue}/personas`, {
      method: "POST",
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": csrfToken
      }
    }).then(response => response.text())
      .then(html => {
        Turbo.renderStreamMessage(html)
      })
  }

  submitForm(event) {
    event.preventDefault()

    if (this.hasContainerTarget) {
      this.containerTarget.classList.add("is-loading")
      this._textLoader()
    }

    const form = this.formTarget
    const csrfToken = document.querySelector("[name='csrf-token']")?.content
    const formData = new FormData(form)

    fetch(`/campaigns/${this.campaignIdValue}/ai_settings`, {
      method: "POST",
      body: formData,
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": csrfToken
      }
    }).then(response => response.text())
      .then(html => {
        Turbo.renderStreamMessage(html)
      })
  }

  _textLoader() {
    const textLoader = this.loaderTextTarget
    const messages = [
      i18n.t("js.back.campaigns.ai_loading_text.step1"),
      i18n.t("js.back.campaigns.ai_loading_text.step2"),
      i18n.t("js.back.campaigns.ai_loading_text.step3"),
      i18n.t("js.back.campaigns.ai_loading_text.step4"),
      i18n.t("js.back.campaigns.ai_loading_text.step5"),
      i18n.t("js.back.campaigns.ai_loading_text.step6")
    ]

    let currentIndex = 0

    const updateText = () => {
      textLoader.textContent = messages[currentIndex]
      currentIndex = currentIndex + 1

      if( currentIndex < messages.length) {
        const randomInterval = Math.random() * 3000 + 4000
        setTimeout(updateText, randomInterval)
      }
    }

    updateText()
  }
}
